<template>
<div>
  <h2>Mapowanie</h2>
  <v-form ref="form">
    <v-text-field v-for="field in fields" :key="field.id" v-model="model[field.id]" :label="field.name"></v-text-field>
    <v-btn @click="submit()">Submit</v-btn>
  </v-form>
</div>
</template>

<script>
export default {
  data() {
    return {
      schema: {},
      model: {},
      map: [],
      schemaFields: []
    }
  },
  computed: {
    fields() {
      let fields = []
      this.schemaFields.forEach(field => {
        fields.push(field)
        if (field['sub-fields'] != undefined) {
          field['sub-fields'].forEach(subField => fields.push(subField))
        }
      })
      return fields
    }
  },
  created() {
    let schema = this.$http.get('schema/' + this.$route.params.schemaId)
    let translations = this.$http.get('document/map/' + this.$route.params.schemaId)

    Promise.all([schema, translations]).then((data) => {
      this.schemaFields = data[0].data.fields
      this.schema = data[0].data
      this.map = data[1].data
      this.initModel()
    }).catch(() => {
      this.$route.push({
        name: "not-found"
      })
    })
  },
  methods: {
    submit() {
      if (!this.$refs.form.validate()) {
        return
      }

      let postData = this.createPostData()
      this.$http.post(`document/map`, postData).then(data => {
        this.map.push(data.data)
        this.$store.commit('setSnack', {
          message: "Dodano mapowanie",
          color: 'success'
        })
      }).catch(() => {
        this.$store.commit('setSnack', {
          message: "Problem z dodaniem tłumaczenia",
          color: 'success'
        })
      })
    },
    createPostData() {
      return {
        'map': this.fieldsMap()
      }
    },
    fieldsMap() {
      let fieldsMap = []
      for (let fieldId in this.model) {
        fieldsMap.push({
          'id_field': fieldId,
          'location': this.model[fieldId]
        })
      }
      return fieldsMap
    },
    initModel() {
      this.map.forEach(fieldMap => this.model[fieldMap['id_field']] = fieldMap['location'])
    }
  },
}
</script>
